import React from 'react'
// import lottie from 'lottie-web'
import "./heroSection.css"
import CameraComponent from '../../components/CameraComponent'
import ShoeComponent from '../../components/ShoeComponent'
import PlaneComponent from '../../components/PlaneComponent'
import BagOpening from '../../components/BagInteractivity'


const HeroCopySection = () => {

  return (

 <>

<div className="uk-section uk-flex uk-flex-middle uk-height-viewport" >
  <div className="uk-width-1-1">
      <div className="uk-container">                
        <div className="uk-grid-margin uk-container uk-container-medium">
          <div className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
              <div className="uk-width-1-1 uk-first-column">

                    <div className='trip-heading-one uk-text-center' uk-scrollspy="cls:uk-animation-slide-bottom-medium; repeat: true">

                    This was the year we learned how to travel again. <br className='uk-visible@l'/> 
                    We explored new terrain, <ShoeComponent alt='shoe' title='shoe'/> rediscovered our favorite spots, <CameraComponent alt="Camera" title="Camera" /> and lived through those long layovers. <PlaneComponent alt="Plane" title="Aerolane" /> Keep scrolling to unpack the memories that made our year.
                    </div>

              </div>
            </div>
          </div>
        </div>
      </div>
</div>

<div id="bag-start-end" className='uk-section uk-margin-remove-top uk-padding-remove-top uk-height-viewport uk-flex uk-flex-top'>
  <div className="uk-container uk-margin-remove-top" uk-parallax="target: #bag-start-end; start: 30vh; end: 30vh; y: 200; easing: 0;">
    <BagOpening />
  </div>
</div>


</> 

  )
}

export default HeroCopySection